import React, { useCallback, useEffect, useState } from "react";
import "./style.css";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import freightService from "../../service/freight.service";
import driverService from "../../service/driver.service";
import CustomPaginationTableFreights from "../../components/GridSimple-home-freight";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { Spin } from "antd";

function ViewerFreights() {
  const [freightList, setFreightList] = useState([]);
  const [activeTab, setActiveTab] = useState("em_transito");
  const [dataFreihtInTravel, setDataFreihtInTravel] = useState(0);
  const [dataFreihtFinised, setDataFreihtFinised] = useState(0);
  const [loading, setLoading] = useState(false);
  const [getAll, setGetAll] = useState(false);
  const [getUIDs, setGetUIDs] = useState([]);
  const [getUID, setGetUID] = useState("");
  const [operationalSegment, setOperationalSegment] = useState("all");
  const [operationalStats, setOperationalStats] = useState({
    comAlerta: 0,
    atrasoPrazo: 0,
    totalNaLista: 0,
  });

  const user = useSelector(state => state.user);

  const handleOperationalStats = useCallback((stats) => {
    setOperationalStats((prev) => ({ ...prev, ...stats }));
  }, []);

  const fetchStoppingPointsByFreight = async (freightId) => {
    return await freightService.getStoppingPointsByFreight(freightId);
  };

  const fetchDateFromFirstStoppingPoint = (stoppingPoints) => {
    const firstValidStoppingPoint = stoppingPoints.docs.find(
      (stoppingPoint) => {
        const stoppingPointObj = stoppingPoint.data();
        return stoppingPointObj.stop_order === 1;
      }
    );

    if (firstValidStoppingPoint) {
      return firstValidStoppingPoint.data().date_operation;
    } else {
      return null;
    }
  };

  const fetchAllFreights = async (activeTab) => {
    try {
      if (activeTab === "em_transito") {
        let freightsInProgress = null;

        if (user.viewALL) {
          freightsInProgress = await freightService.getFreightsInProgressAll();
        }
        else {
          if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

            if (uids.length > 1) {
              freightsInProgress = await freightService.getFreightsInProgressMultiplesUIDs(uids);
            }
            else {
              freightsInProgress = await freightService.getFreightsInProgress(user.uidShipper);
            }
          }
          else {
            freightsInProgress = await freightService.getFreightsInProgress(user.uidShipper);
          }
        }

        const allFreights = [...freightsInProgress.docs];

        const freightListPromises = allFreights.map(async (freight) => {
            const freightObj = freight.data();
            const freightId = freight.id;

            const stoppingPoints = await fetchStoppingPointsByFreight(freightId);
            const loadingDate = stoppingPoints
                ? fetchDateFromFirstStoppingPoint(stoppingPoints)
                : "Data de carregamento ainda não definida";

            const driverUid = freightObj.freight.getDriverFreight?.uidDriver;
            const driver = driverUid
                ? await driverService.getDriverAvailable(driverUid)
                : null;
            const driverName = driver?.data()?.name || "Não informado";

            return {
                id: freightId,
                driverName,
                loadingDate,
                stoppingQt: stoppingPoints?.size || 0,
                ...freightObj,
            };
          });

          const freightList = await Promise.all(freightListPromises);

          setFreightList(freightList);
      }
      else {

        let freightsInProgress = null;
        let freightsDelivered = null;

        if (user.viewALL) {
          freightsInProgress = await freightService.getFreightsInProgressAll();
        }
        else {
          if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

            if (uids.length > 1) {
              freightsInProgress = await freightService.getFreightsInProgressMultiplesUIDs(uids);
            }
            else {
              freightsInProgress = await freightService.getFreightsInProgress(user.uidShipper);
            }
          }
          else {
            freightsInProgress = await freightService.getFreightsInProgress(user.uidShipper);
          }
        }

        if (user.viewALL) {
          freightsDelivered = await freightService.freightAllFinalizado();
        }
        else {
          if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

            if (uids.length > 1) {
              freightsDelivered = await freightService.freightFinalizadoMultiplesUIDs(uids);
            }
            else {
              freightsDelivered = await freightService.freightFinalizadoUid(user.uidShipper);
            }
          }
          else {
            freightsDelivered = await freightService.freightFinalizadoUid(user.uidShipper);
          }
        }

        const allFreights = [...freightsInProgress.docs, ...freightsDelivered.docs];

        const freightListPromises = allFreights.map(async (freight) => {
            const freightObj = freight.data();
            const freightId = freight.id;

            const stoppingPoints = await fetchStoppingPointsByFreight(freightId);
            const loadingDate = stoppingPoints
                ? fetchDateFromFirstStoppingPoint(stoppingPoints)
                : "Data de carregamento ainda não definida";

            const driverUid = freightObj.freight.getDriverFreight?.uidDriver;
            const driver = driverUid
                ? await driverService.getDriverAvailable(driverUid)
                : null;
            const driverName = driver?.data()?.name || "Não informado";

            return {
                id: freightId,
                driverName,
                loadingDate,
                stoppingQt: stoppingPoints?.size || 0,
                ...freightObj,
            };
          });

          const freightList = await Promise.all(freightListPromises);

          setFreightList(freightList);
      }
    } catch (error) {
        console.log(error);
    }
  };

  useEffect(() => {
    if (user.viewALL) {
      setGetAll(true);
    }
    else {
      if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
        const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
        const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
        const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

        if (uids.length > 1) {
          setGetUIDs(uids);
        }
        else {
          setGetUID(user.uidShipper);
        }
      }
      else {
        setGetUID(user.uidShipper);
      }
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        await fetchAllFreights(activeTab);
      } catch (e) {
        console.log(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    if (user.viewALL) {
      freightService.getFreightsInProgressAll()
      .then(async (item) => {
        setDataFreihtInTravel(item?.size);
      })
      .catch((erro) => {
        console.log(erro);
      });
    }
    else {
      if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
        const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
        const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
        const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

        if (uids.length > 1) {
          freightService.getFreightsInProgressMultiplesUIDs(uids)
          .then(async (item) => {
            setDataFreihtInTravel(item?.size);
          })
          .catch((erro) => {
            console.log(erro);
          });
        }
        else {
          freightService
            .freightInTravel(user.uidShipper)
            .then(async (item) => {
              setDataFreihtInTravel(item?.size);
            })
            .catch((erro) => {
              console.log(erro);
            });
        }
      }
      else {
        freightService
          .freightInTravel(user.uidShipper)
          .then(async (item) => {
            setDataFreihtInTravel(item?.size);
          })
          .catch((erro) => {
            console.log(erro);
          });
      }
    }

    if (user.viewALL) {
      freightService.freightAllFinalizado()
        .then(async (item) => {
          setDataFreihtFinised(item?.size);
        })
        .catch((erro) => {
          console.log(erro);
        });
    }
    else {
      if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
        const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
        const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
        const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

        if (uids.length > 1) {
          freightService.freightFinalizadoMultiplesUIDs(uids)
          .then(async (item) => {
            setDataFreihtFinised(item?.size);
          })
          .catch((erro) => {
            console.log(erro);
          });
        }
        else {
        freightService
            .freightFinalizadoUid(user.uidShipper)
            .then(async (item) => {
              setDataFreihtFinised(item?.size);
            })
            .catch((erro) => {
              console.log(erro);
            });
        }
      }
      else {
      freightService
          .freightFinalizadoUid(user.uidShipper)
          .then(async (item) => {
            setDataFreihtFinised(item?.size);
          })
          .catch((erro) => {
            console.log(erro);
          });
      }
    }

    return () => {
      cancelled = true;
    };
  }, [activeTab, user]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setOperationalSegment("all");
  };

  const goOperacionalEmTransito = () => {
    setActiveTab("em_transito");
    setOperationalSegment("all");
  };

  return (
    <>
      {useSelector((state) => state.usuarioLogado) > 0 ? (
        <NewMiniDrawer
          divOpen={
            <div className="freight-acomp">
              <header className="freight-acomp__header">
                <h1>Acompanhamento de entregas</h1>
                <p className="freight-acomp__subtitle">
                  Priorize fretes com risco operacional (GPS, offline, prazo). Use os cards e os filtros de prioridade
                  sobre a tabela.
                </p>
              </header>

              <div className="freight-acomp__stats">
                <button
                  type="button"
                  className="freight-acomp__stat-card freight-acomp__stat-card--transit freight-acomp__stat-card--click"
                  onClick={goOperacionalEmTransito}
                >
                  <span className="freight-acomp__stat-label">Em trânsito (frota)</span>
                  <span className="freight-acomp__stat-value">
                    {dataFreihtInTravel ?? 0}
                  </span>
                  <span className="freight-acomp__stat-hint">Ver todos em trânsito</span>
                </button>
                <button
                  type="button"
                  className="freight-acomp__stat-card freight-acomp__stat-card--deliveries freight-acomp__stat-card--click"
                  onClick={() => {
                    setActiveTab("em_transito");
                    setOperationalSegment("com_alerta");
                  }}
                >
                  <span className="freight-acomp__stat-label">Alertas operacionais</span>
                  <span className="freight-acomp__stat-value">
                    {operationalStats.comAlerta ?? 0}
                  </span>
                  <span className="freight-acomp__stat-hint">GPS acima de 45 min ou offline</span>
                </button>
                <button
                  type="button"
                  className="freight-acomp__stat-card freight-acomp__stat-card--issues freight-acomp__stat-card--click"
                  onClick={() => {
                    setActiveTab("em_transito");
                    setOperationalSegment("atraso_prazo");
                  }}
                >
                  <span className="freight-acomp__stat-label">Prazo em risco</span>
                  <span className="freight-acomp__stat-value">
                    {operationalStats.atrasoPrazo ?? 0}
                  </span>
                  <span className="freight-acomp__stat-hint">Entrega acordada ultrapassada</span>
                </button>
                <article className="freight-acomp__stat-card freight-acomp__stat-card--finished">
                  <span className="freight-acomp__stat-label">Finalizados (frota)</span>
                  <span className="freight-acomp__stat-value">
                    {dataFreihtFinised ?? 0}
                  </span>
                  <span className="freight-acomp__stat-hint">Indicador geral</span>
                </article>
              </div>

              <section className="freight-acomp__panel">
                <div className="freight-acomp__tabs" role="tablist">
                  <button
                    type="button"
                    role="tab"
                    className={
                      activeTab === "em_transito"
                        ? "freight-acomp__tab freight-acomp__tab--active"
                        : "freight-acomp__tab"
                    }
                    onClick={() => handleTabClick("em_transito")}
                    aria-selected={activeTab === "em_transito"}
                  >
                    Em trânsito
                  </button>
                  <button
                    type="button"
                    role="tab"
                    className={
                      activeTab === "todos"
                        ? "freight-acomp__tab freight-acomp__tab--active"
                        : "freight-acomp__tab"
                    }
                    onClick={() => handleTabClick("todos")}
                    aria-selected={activeTab === "todos"}
                  >
                    Todos
                  </button>
                </div>
                <div className="freight-acomp__filters" role="group" aria-label="Prioridade operacional">
                  <span className="freight-acomp__filters-label">Prioridade na lista</span>
                  <div className="freight-acomp__chips">
                    <button
                      type="button"
                      className={
                        operationalSegment === "all"
                          ? "freight-acomp__chip freight-acomp__chip--active"
                          : "freight-acomp__chip"
                      }
                      onClick={() => setOperationalSegment("all")}
                    >
                      Todos
                    </button>
                    <button
                      type="button"
                      className={
                        operationalSegment === "com_alerta"
                          ? "freight-acomp__chip freight-acomp__chip--active"
                          : "freight-acomp__chip"
                      }
                      onClick={() => setOperationalSegment("com_alerta")}
                    >
                      Com alerta
                    </button>
                    <button
                      type="button"
                      className={
                        operationalSegment === "atraso_prazo"
                          ? "freight-acomp__chip freight-acomp__chip--active"
                          : "freight-acomp__chip"
                      }
                      onClick={() => setOperationalSegment("atraso_prazo")}
                    >
                      Prazo em risco
                    </button>
                  </div>
                </div>
                <Spin spinning={loading} tip="Carregando fretes...">
                  <CustomPaginationTableFreights
                    list={freightList}
                    operationalSegment={operationalSegment}
                    onOperationalStats={handleOperationalStats}
                  />
                </Spin>
              </section>
            </div>
          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default ViewerFreights;